import EmptyState from 'owa-empty-state/lib/components/EmptyState';
import { getIsLightBaseTheme } from 'owa-theme';
import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-agenda-strings';

const styles = require('./EmptyState.scss');

/**
 * initialize the svgs icons
 */
let EMPTY_STATE;
function initializeDisplayIconsForEmptyList() {
    if (getIsLightBaseTheme()) {
        // colored svgs that goes with the blue base theme
        EMPTY_STATE = require('owa-empty-state/lib/svg/colored/balloon.svg');
    } else {
        // gray scale svgs
        EMPTY_STATE = require('owa-empty-state/lib/svg/gray/balloon.svg');
    }
}

export const EventsEmptyState = observer(function EventsEmptyState() {
    initializeDisplayIconsForEmptyList();
    return (
        <div className={styles.emptyStateContainer}>
            <EmptyState
                icon={EMPTY_STATE}
                detailMessage={strings.agendaPaneEmptyStateSecondaryText}
                mainMessage={strings.agendaPaneEmptyStatePrimaryText}
            />
        </div>
    );
});
